import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useSelector } from 'react-redux';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import PriceChangeBanner from './PriceChangeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const legacyPriceChanges = {
  [CurrencyCodes.USD]: 1500,
  [CurrencyCodes.EUR]: 1470,
  [CurrencyCodes.GBP]: 1310,
  [CurrencyCodes.AUD]: 2160,
  [CurrencyCodes.JPY]: 180000,
  [CurrencyCodes.SGD]: 2100,
  [CurrencyCodes.CAD]: 1950,
  [CurrencyCodes.COP]: 4500000
};
const tbPriceChanges = {
  [CurrencyCodes.USD]: 150,
  [CurrencyCodes.EUR]: 150,
  [CurrencyCodes.GBP]: 135,
  [CurrencyCodes.AUD]: 220,
  [CurrencyCodes.JPY]: 18000,
  [CurrencyCodes.SGD]: 210,
  [CurrencyCodes.CAD]: 195,
  [CurrencyCodes.COP]: 450000
};
const ServiceHubPriceChangeBanner = () => {
  const currencyCode = useSelector(activeCurrencySelector);
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const isSeatsTBPortal = useSelector(hasAnyTBSkuInProductDataSelector);
  const priceChanges = isUngatedForSeats ? isSeatsTBPortal ? tbPriceChanges : null : legacyPriceChanges;
  if (!priceChanges) return null;
  const price = priceChanges[currencyCode];
  return /*#__PURE__*/_jsx(PriceChangeBanner, {
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `pricingPage.banners.priceChanges.SERVICE.description.${isUngatedForSeats ? 'perMonthPerSeat' : 'perMonth'}_jsx`,
      elements: {
        Price: PriceDisplay
      },
      options: {
        price,
        currencyCode
      }
    })
  });
};
export default ServiceHubPriceChangeBanner;